import type { CreateProfessionInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateProfessionMutation } from '../hooks/use-profession-mutations'
import { ProfessionForm } from './profession-form'

type ProfessionCreatePanelProps = {
  onDone?: () => void
}

/** "Nueva profesión" dentro del side panel: el mismo ProfessionForm que la edición. */
export function ProfessionCreatePanel({ onDone }: ProfessionCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateProfessionMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateProfessionInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <ProfessionForm
      submitLabel="Crear profesión"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
